import React from 'react'
import Purchase from './Purchase/Purchase'
import My_Account_Tabs from './my_account_tabs/My_Account_Tabs'

function Account() {
  return (
    <>

    <My_Account_Tabs/>

    </>
  )
}

export default Account